import React, { useState, useEffect } from 'react';
import SbEditable from 'storyblok-react';
import Image from '~/components/Dynamic/Image';
import TextCard from '~/components/Dynamic/TextCard';

function FeaturesSlider({ blok }) {
  const slides = blok?.slides;

  const [selectedTab, setSelectedTab] = useState(0);
  const [clicked, setClicked] = useState(false);
  let timeout;

  useEffect(() => {

    if (!clicked) {
      timeout = setTimeout(() => {
        setSelectedTab((selectedTab + 1) === slides.length ? 0 : selectedTab + 1);
      }, 6000);
    } else {
      clearTimeout(timeout);
    }

    return () => timeout && clearTimeout(timeout);
  }, [selectedTab]);

  return (
    <section className={`bg-black text-white my-14 py-20 md:py-28`}>
      <div className="container">
        <header className="flex justify-center pb-12 lg:pb-24">
          <TextCard blok={blok.textCard[0]} />
        </header>

        <div className="flex flex-wrap items-center justify-center -ml-20">
          <div className="flex-auto w-full max-w-4xl pl-20 md:w-auto">
            <div className="w-full aspect-w-700 aspect-h-475">
              <div>
                <Image
                  blok={slides[selectedTab].image}
                  imageClassName="h-full w-full object-contain"
                  className="object-contain w-full h-full"
                />
              </div>
            </div>
          </div>

          <div className="flex w-full pl-20 mt-6 md:mt-12 lg:w-1/3 lg:mt-0" onClick={() => setClicked(true)}>
            <div className="flex flex-col w-full md:w-auto justify-between md:flex-row lg:flex-col">
              <div className="grid grid-cols-3 gap-8  md:hidden">
                {slides.map((item, i) => (
                  <div className="py-6 cursor-pointer" onClick={() => setSelectedTab(i)}>
                    <div className={`w-full h-0.5  bg-grey relative overflow-hidden`} >
                      <div className={`absolute top-0 left-0 w-full h-full bg-blue transform -translate-x-full ${(!clicked && (selectedTab === i)) && 'animate-progress-x'} ${(clicked && (selectedTab === i)) && 'translate-x-0'}`} style={{animationDuration: '6s'}}></div>
                    </div>
                  </div>
                ))}
              </div>
              {slides.map((item, i) => (
                <SbEditable content={item} key={item._uid}>
                  <div
                    onClick={() => setSelectedTab(i)}
                    className={`flex flex-col items-start md:items-center text-white select-none cursor-pointer md:mx-6 lg:mx-0 md:items-start ${((selectedTab !== i)) && 'hidden md:block'} ${i < slides.length -1 && 'md:mb-12'}`}
                  >
                    <div className={`w-full h-0.5 mb-6 bg-grey relative overflow-hidden hidden md:block`}>
                      <div className={`absolute top-0 left-0 w-full h-full bg-blue transform -translate-x-full ${(!clicked && (selectedTab === i)) && 'animate-progress-x'} ${(clicked && (selectedTab === i)) && 'translate-x-0'}`} style={{animationDuration: '6s'}}></div>
                    </div>
                   <div className="md:pr-8 w-full">
                    <p className="mb-2 font-bold text-20px">{item.textCard[0].heading}</p>
                    <p className="md:max-w-sm">{item.textCard[0].content}</p>
                   </div>
                  </div>
                </SbEditable>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FeaturesSlider;
